export default __webpack_public_path__ + "2880c38fd9230623bda0ebf50a70784a.svg";